import { readonly, ref, computed } from 'vue';
import type { TemplateVariable } from '../../api/template-variables';
import { compareByOrder } from '@/shared/legacy/lib/compators/compators';

function makeTemplateVariablesConfig() {
  const templateVariables = ref<Array<TemplateVariable>>();
  const readonlyTemplateVariables = readonly(templateVariables);
  return {
    templateVariables: readonlyTemplateVariables,
    setTemplateVariables: (items: Array<TemplateVariable>) => {
      const value = [...items].sort(compareByOrder);
      templateVariables.value = value;
      return value;
    },
    mailVariables: computed(() => readonlyTemplateVariables.value?.filter(({ available }) => available).map(({ id }) => id)),
    smsVariables: computed(() => readonlyTemplateVariables.value?.filter(({ available_sms }) => available_sms).map(({ id }) => id)),
    imVariables: computed(() => readonlyTemplateVariables.value?.filter(({ available_im }) => available_im).map(({ id }) => id))
  };
}

export const templateVariables = makeTemplateVariablesConfig();
